angular.
module("dx.webapp.library").
directive("dxLibraryGradingMatrixItem", function libraryGradingMatrixItemDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			item: "=",
		},
		templateUrl: "tmpl/library/library-grading-matrix-item-directive.html",
		replace: true,
		link: link,
		controller: "DxLibraryGradingMatrixItemController",
	};

	function link($scope, element) {
		element.draggable({
			distance: 5,
			zIndex: 9999,
			cursorAt: {
				bottom: 10,
				right: 10,
			},
			helper: function helper() {
				return angular.element("<div class='draggableHelper'></div>").
					data("dropareaData", $scope.item).
					text($scope.item.title).
					hide().
					fadeIn("fast");
			},
		});
	}
});
